export const adminCampaignsApi = {

    getAll () {
        return axios.get(`/api/admin/campaign`)
    },

}
